import { useEffect } from 'react';

import { useSecureJsonCollectionsStore } from '@/shared/lib/sj-orm';
import { useSyncQueueStore } from '@/shared/lib/sj-orm/synchronizer/sync-queue.store';

export const usePreventUnload = () => {
  const sjcStore = useSecureJsonCollectionsStore();
  const syncQueueStore = useSyncQueueStore();

  useEffect(() => {
    const synced = sjcStore.operations.length === 0 && syncQueueStore.jobs.length === 0;
    if (synced) {
      return undefined;
    }

    const handelBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = true;
    };

    // TODO move to shared/hooks/useBeforeUnload
    window.addEventListener('beforeunload', handelBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handelBeforeUnload);
    };
  }, [sjcStore.operations, syncQueueStore.jobs]);
};
